import { useEffect, useState } from "react";
import {
  Button,
  MenuItem,
  CircularProgress,
  Grid,
  InputLabel,
  FormControl,
  Box,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Checkbox,
  Autocomplete,
} from "@mui/material";
import Select from "@mui/material/Select";
import Iconify from "../iconify";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import { get, post, put } from "src/utils/networkUtils";
const icon = <Iconify icon="eva:person-add-outline" sx={{}} />;
const checkedIcon = <Iconify icon="eva:person-add-outline" sx={{}} />;
const dateFormat = "YYYY-MM-DD HH:mm:ss";
const defaultStage = {
  name: "",
  identifier: "",
  startDate: moment().format(dateFormat),
  endDate: moment().format(dateFormat),
  breakdown: "",
  isCompleted: false,
  prizePool: "",
  scoreableId: null,
};
export default function ContestQuestionDialog(props) {
  const [scoreables, setScoreables] = useState([]);
  const [question, setQuestion] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedScoreables, setSelectedScoreables] = useState([]);

  useEffect(() => {
    if (props?.question) {
      setQuestion(props.question);
    } else {
      setQuestion(defaultStage);
    }
    get(`/admin/scoreables`).then(function (response) {
      setScoreables(response.scoreables);
      if (props?.question) {
        const index = response.scoreables.findIndex(
          (item) => item.scoreableId === props.question?.scoreable.scoreableId
        );
        console.log("index", index);
        setSelectedScoreables([response.scoreables[index]]);
        setQuestion((prevState) => ({
          ...prevState,
          scoreableId: props.question?.scoreable.scoreableId,
        }));
      }
    });
  }, [props?.question]);

  const handleChange = (e) => {
    const { id, value } = e.target;
    setQuestion((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  };

  const onSuccess = () => {
    setLoading(true);
    question.tenantId = 1;
    if (props?.question) {
      put(
        `/admin/minigames/contests/${props.contestId}/questions/${question.questionId}`,
        question
      ).then(function (response) {
        props.onSuccessHandler();
      });
    } else {
      post(
        `/admin/minigames/contests/${props.contestId}/questions`,
        question
      ).then(function (response) {
        props.onSuccessHandler();
      });
    }
  };
  const onCancel = () => {
    props.onClose();
  };

  const handleDateChange = (newValue, fieldName) => {
    setQuestion((prevState) => ({
      ...prevState,
      [fieldName]: moment(newValue).format(dateFormat),
    }));
  };
  const handleScoreableChange = (scoreables) => {
    setSelectedScoreables([...scoreables]);
    setQuestion((prevState) => ({
      ...prevState,
      scoreableId: scoreables.length > 0 ? scoreables[0].scoreableId : null,
    }));
  };

  return (
    <Dialog
      open={props.open}
      onClose={() => {}}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Question</DialogTitle>
      <DialogContent>
        {question === null || loading ? (
          <Box
            sx={{ display: "flex", justifyContent: "center" }}
            style={{ padding: 20 }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Grid container>
            <Grid item xs={3} sx={{ m: 0, p: 1 }}>
              <TextField
                id="targetValue"
                label="Target Value"
                fullWidth
                value={question.targetValue}
                variant="standard"
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={6} sx={{ m: 0, p: 1 }}>
              <FormControl fullWidth>
                <InputLabel id="type-select-label">Stat</InputLabel>
                <Select
                  labelId="type-label"
                  id="type-select"
                  value={question.statsType}
                  label="Type"
                  onChange={(event) =>
                    setQuestion((prevState) => ({
                      ...prevState,
                      statsType: event.target.value,
                    }))
                  }
                >
                  <MenuItem value="0">None</MenuItem>
                  <MenuItem value="1">Goals</MenuItem>
                  <MenuItem value="2">Assists</MenuItem>
                  <MenuItem value="3">Runs</MenuItem>
                  <MenuItem value="4">Wickets</MenuItem>
                  <MenuItem value="5">Catches</MenuItem>
                  <MenuItem value="7">Points</MenuItem>
                  <MenuItem value="8">Rebounds</MenuItem>
                  <MenuItem value="9">Assists</MenuItem>
                  <MenuItem value="11">Blocks</MenuItem>
                  {/* <MenuItem value="3">Shots On Target</MenuItem> */}
                  {/* <MenuItem value="4">Tackle</MenuItem> */}
                  {/* <MenuItem value="5">Team Goal</MenuItem> */}
                  {/* <MenuItem value="6">Team Save</MenuItem> */}
                  {/* <MenuItem value="10">Steals</MenuItem> */}
                  {/* <MenuItem value="12">Tournovers</MenuItem> */}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={3} sx={{ m: 0, p: 1 }}>
              <TextField
                id="prize"
                label="Prize"
                fullWidth
                value={question.prize}
                variant="standard"
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={6} sx={{ mt: 1, p: 1 }}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DateTimePicker
                  label="Start Date"
                  value={moment(question.startDate, dateFormat)}
                  onChange={(value) => handleDateChange(value, "startDate")}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={6} sx={{ mt: 1, p: 1 }}>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <DateTimePicker
                  label="End Date"
                  value={moment(question.endDate, dateFormat)}
                  onChange={(value) => handleDateChange(value, "endDate")}
                  renderInput={(params) => <TextField {...params} />}
                />
              </LocalizationProvider>
            </Grid>
            <Grid item xs={12} sx={{ m: 0, p: 1 }}>
              <Autocomplete
                value={selectedScoreables}
                multiple
                id="checkboxes-tags-demo"
                options={scoreables}
                onChange={(event, value) => handleScoreableChange(value)}
                getOptionLabel={(option) => option?.displayName}
                renderOption={(props, option, { selected }) => (
                  <li {...props} key={option.scoreableId}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={selected}
                    />
                    {option?.displayName} {option?.team && ` (${option?.team})`}
                  </li>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Question Scoreable"
                    placeholder="Scoreable"
                  />
                )}
              />
            </Grid>
          </Grid>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onCancel()}>Cancel</Button>
        <Button
          onClick={() => onSuccess()}
          autoFocus
          disabled={question === null || question.scoreableId === null}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
